import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box, Stack, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import useEntity from "../../hooks/useEntity";

import Sku from "./Sku";

const Skus = ({ data, clientId, onSelect, onSave }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { getTitle, getMessage } = useLocalization();

  const { setEntity, entityData, setEntityData, emptyObject, saveEntityData } =
    useEntity();

  const [saved, setSaved] = useState(false);

  useEffect(() => {
    console.log("[Skus.useEffect]. clientId: ", clientId);
    setEntity("SKU");
  }, []);

  const handleSelect = (sku) => {
    onSelect(sku);
  };

  const handleSave = async (newSku) => {
    const data = {
      id: null,
      clientId,
      name: newSku.name,
      name_fr: newSku.name_fr,
    };

    await saveEntityData(data);
    setSaved(true);
  };

  useEffect(() => {
    if (!saved) {
      return;
    }
    onSave();
    setSaved(false);
  }, [saved]);

  return (
    <Box sx={{ padding: "8px" }}>
      {Array.isArray(data) && data.length > 0 ? (
        <Stack spacing={1}>
          {data.map((sku, index) => (
            <Sku
              key={sku?.id || sku?._id || `${sku?.name || "sku"}-${index}`}
              sku={sku}
              clientId={clientId}
              onClick={handleSelect}
            />
          ))}
        </Stack>
      ) : (
        <Typography>{getMessage("noRecords")}</Typography>
      )}
    </Box>
  );
};

export default Skus;
